import { Card, makeStyles, tokens } from '@fluentui/react-components';
import { PageHeader } from '../../common/PageHeader';
import { LoadingState } from '../../common/LoadingState';
import { ErrorState } from '../../common/ErrorState';
import { useDashboard } from '../../../hooks/useDashboard';
import { KpiWidget } from './KpiWidget';
import { RevenueChart } from './RevenueChart';
import { AlertsPanel } from './AlertsPanel';
import { RecentActivity } from './RecentActivity';

const useStyles = makeStyles({
  grid: { display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: tokens.spacingHorizontalM },
  content: { display: 'grid', gridTemplateColumns: '2fr 1fr', gap: tokens.spacingHorizontalM, marginTop: tokens.spacingVerticalL, alignItems: 'start' },
});

export const DashboardPage = () => {
  const styles = useStyles();
  const { kpis, recentActivity, revenueSeries, alerts, loading, error, reload } = useDashboard();

  if (loading) return <LoadingState label="Loading dashboard..." />;
  if (error) return <ErrorState message={error} onRetry={() => void reload()} />;

  return (
    <div>
      <PageHeader title="Dashboard" subtitle="Commercial overview for CRM Partner Center" />
      <div className={styles.grid}>{kpis.map((item) => <KpiWidget key={item.label} item={item} />)}</div>
      <div className={styles.content}>
        <div>
          <RevenueChart data={revenueSeries} />
          <Card style={{ marginTop: 16 }}>
            <RecentActivity items={recentActivity} />
          </Card>
        </div>
        <AlertsPanel alerts={alerts} />
      </div>
    </div>
  );
};
